import Raven from 'raven-js';
import { getPrimaryTabUtil } from '../../../utils/PrimaryTabUtil';
import { startPushNotificationSubscription } from '../startPushNotificationSubscription';
import { isPushSubscriptionChangedMessageEvent } from './serviceWorkerMessages';
export const listenToPushSubscriptionChanged = serviceWorkerRegistration => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', messageEvent => {
      if (getPrimaryTabUtil().isPrimary && isPushSubscriptionChangedMessageEvent(messageEvent)) {
        /* The service worker has notified us to resubscribe. It will have written an event
        to the indexed db that will force the start notifications logic to consider
        the existing subscription as stale */
        startPushNotificationSubscription(serviceWorkerRegistration).catch(e => {
          Raven.captureException(e);
        });
      }
    });
  }
};